import React, { useEffect, useRef, useState } from "react";
import "./inner-pages.css";

function newQuestion() {
  return { left: Math.floor(Math.random() * 8) + 2, right: Math.floor(Math.random() * 8) + 2 };
}

export default function Contact({ t }) {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [status, setStatus] = useState("idle");
  const [question, setQuestion] = useState(newQuestion);
  const [answer, setAnswer] = useState("");
  const [website, setWebsite] = useState("");
  const [challengeError, setChallengeError] = useState(false);
  const [cooldown, setCooldown] = useState(false);
  const cooldownTimer = useRef(null);

  useEffect(() => () => clearTimeout(cooldownTimer.current), []);

  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }
  async function handleSubmit(e) {
    e.preventDefault();
    if (status === "sending" || cooldown || website) return;
    if (Number(answer) !== question.left + question.right || answer.trim() === "") {
      setChallengeError(true);
      return;
    }
    setChallengeError(false);
    setStatus("sending");
    try {
      const response = await fetch("/send-email.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(form),
      });
      const result = await response.json();
      if (!response.ok || !result.success) throw new Error("Message not sent");
      setForm({ name: "", email: "", phone: "", message: "" });
      setAnswer("");
      setQuestion(newQuestion());
      setStatus("success");
      setCooldown(true);
      cooldownTimer.current = setTimeout(() => setCooldown(false), 30000);
    } catch (error) {
      setStatus("error");
    }
  }

  return (
    <div className="inner-page">
      <section className="inner-page__intro contact-intro">
        <div className="container contact-intro__layout">
          <div>
            <span className="inner-page__eyebrow">Italiano988 / {t("contact.title")}</span>
            <h1>{t("contact.heading")}</h1>
            <p>{t("contact.subtitle")}</p>
          </div>
          <div className="contact-art" aria-hidden="true">
            <span className="contact-art__ring contact-art__ring--outer" />
            <span className="contact-art__ring contact-art__ring--inner" />
            <span className="contact-art__dot contact-art__dot--one" />
            <span className="contact-art__dot contact-art__dot--two" />
            <span className="contact-art__envelope"><i className="bi bi-envelope-paper" /></span>
            <span className="contact-art__caption">LET'S CONNECT / ITALIANO988</span>
          </div>
        </div>
      </section>
      <section className="inner-page__body" aria-label={t("contact.title")}>
        <div className="container contact-layout">
          <form className="contact-panel" onSubmit={handleSubmit}>
            <h2>{t("contact.formTitle")}</h2>
            <div className="row g-3">
              <div className="col-md-6">
                <label className="form-label" htmlFor="contact-name">{t("contact.name")}</label>
                <input id="contact-name" name="name" className="form-control" value={form.name} onChange={handleChange} required />
              </div>
              <div className="col-md-6">
                <label className="form-label" htmlFor="contact-email">{t("contact.email")}</label>
                <input id="contact-email" type="email" name="email" className="form-control" value={form.email} onChange={handleChange} required />
              </div>
              <div className="col-12">
                <label className="form-label" htmlFor="contact-phone">{t("contact.phone")}</label>
                <input id="contact-phone" name="phone" className="form-control" value={form.phone} onChange={handleChange} />
              </div>
              <div className="col-12">
                <label className="form-label" htmlFor="contact-message">{t("contact.message")}</label>
                <textarea id="contact-message" name="message" className="form-control" rows="5" value={form.message} onChange={handleChange} required />
              </div>
              <div className="col-sm-6">
                <label className="form-label" htmlFor="contact-answer">{t("contact.challenge")} {question.left} + {question.right} =</label>
                <input id="contact-answer" type="number" inputMode="numeric" className="form-control" value={answer}
                  onChange={(e) => { setAnswer(e.target.value); setChallengeError(false); }} required />
                {challengeError && <div className="text-danger mt-1" role="alert">{t("contact.challengeError")}</div>}
              </div>
            </div>
            <div aria-hidden="true" style={{ position: "absolute", width: 1, height: 1, overflow: "hidden", clipPath: "inset(50%)" }}>
              <label htmlFor="contact-website">Website</label>
              <input id="contact-website" name="website" tabIndex="-1" autoComplete="off" value={website} onChange={(e) => setWebsite(e.target.value)} />
            </div>
            <button className="contact-panel__submit mt-4" type="submit" disabled={status === "sending" || cooldown}>
              <i className="bi bi-send" aria-hidden="true" />{t("contact.send")}
            </button>
            {status === "success" && <div className="alert alert-success mt-3 mb-0" role="status">{t("contact.success")}</div>}
            {status === "error" && <div className="alert alert-danger mt-3 mb-0" role="alert">{t("contact.error")}</div>}
          </form>
          <aside className="contact-info">
            <h2>{t("contact.info")}</h2>
            <div className="contact-info__row"><span className="contact-info__icon"><i className="bi bi-geo-alt" aria-hidden="true" /></span><span>{t("contact.address")}</span></div>
            <div className="contact-info__row"><span className="contact-info__icon"><i className="bi bi-telephone" aria-hidden="true" /></span><span><a href="tel:+8619540597714" dir="ltr">{t("contact.mobile")}</a></span></div>
            <div className="contact-info__row"><span className="contact-info__icon"><i className="bi bi-envelope" aria-hidden="true" /></span><span><a href="mailto:info@Italiano988.com">{t("contact.mail")}</a></span></div>
          </aside>
        </div>
      </section>
    </div>
  );
}
